<template>
    <v-app-bar app elevate-on-scroll v-if="user">
        <v-app-bar-nav-icon @click.stop="emit('clicked-hamburger')"></v-app-bar-nav-icon>
        <div class="breadcrumbs">
            <!-- Vuetify beta breadcrumbs are fucked - can't use -->
            <span v-for="(item, index) of breadCrumbsStore.items" :key="index" class="breadcrumb">
                <v-btn v-if="item.to" :to="item.to">{{ item.text }}</v-btn>
                <div v-else class="breadcrumb-text">{{ item.text }}</div>
                <div v-if="index < breadCrumbsStore.items.length - 1" class="slash">/</div>
            </span>
        </div>
        <v-spacer />

        <SpaClientSelector class="ma-2" />

        <v-btn @click="emit('clicked-search')" class="ma-2" color="indigo" icon>
            <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <v-menu v-if="user" min-width="200px" rounded location="start top">
            <template v-slot:activator="{ props }">
                <v-btn icon v-bind="props">
                    <v-avatar>
                        <img :src="user.picture" referrerpolicy="no-referrer" />
                    </v-avatar>
                </v-btn>
            </template>
            <v-card>
                <div class="mx-auto text-center pa-4">
                    <v-avatar>
                        <img :src="user.picture" referrerpolicy="no-referrer" />
                    </v-avatar>
                    <h3>{{ user.name }}</h3>
                    <p class="text-caption mt-1">
                        {{ user.email }}
                    </p>
                    <v-divider class="my-3"></v-divider>
                    <v-btn depressed rounded variant="text" @click="logout">Logout</v-btn>
                </div>
            </v-card>
        </v-menu>

        <template v-slot:extension v-if="showVesselInfoBanner && vesselStore.sharedVesselInfo">
            <v-banner color="white" bg-color="deep-orange-darken-1" lines="one">
                <template v-slot:prepend>
                    <v-icon icon="mdi-eye-circle" color="white" />
                </template>
                <v-banner-text class="bannerText"
                    >Viewing as
                    <v-tooltip :text="vesselStore.sharedVesselInfo.roleDescription">
                        <template v-slot:activator="{ props }">
                            <span v-bind="props">{{ vesselStore.sharedVesselInfo.roleTitle }}</span>
                        </template></v-tooltip
                    >, shared from Account #{{ vesselStore.sharedVesselInfo.owningAccountId }}</v-banner-text
                >
                <template v-slot:actions>
                    <v-btn
                        v-if="vesselStore.vessel"
                        size="small"
                        rounded="xl"
                        variant="tonal"
                        color="white"
                        append-icon="mdi-arrow-right-top-bold"
                        :to="{
                            name: 'VesselDetails',
                            params: { accountId: vesselStore.sharedVesselInfo.owningAccountId, vesselId: vesselStore.vessel.vesselId }
                        }"
                        >View in Owning Account</v-btn
                    >
                </template>
            </v-banner>
        </template>
    </v-app-bar>
</template>

<script lang="ts" setup>
import { useAuth0 } from '@auth0/auth0-vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { logout } from '../lib/auth'
import { useBreadCrumbsStore } from '../stores/breadCrumbs'
import { useVesselStore } from '../stores/vessel'
import SpaClientSelector from './SpaClientSelector.vue'

const vesselStore = useVesselStore()

const emit = defineEmits(['clicked-search', 'clicked-hamburger'])
const auth = useAuth0()
const route = useRoute()

const user = auth.user

const breadCrumbsStore = useBreadCrumbsStore()

const showVesselInfoBanner = computed(() => {
    return vesselStore.sharedVesselInfo !== undefined && route.meta.showSharedVesselInfoBanner === true
})
</script>

<style lang="scss" scope>
H3 {
    font-weight: 300;
    text-align: center;
}

.breadcrumbs {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;

    .breadcrumb {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .breadcrumb-text {
        color: #555;
        margin: 0 12px;
    }

    .slash {
        font-size: 20px;
        color: #aaa;
        font-weight: 100;
    }
}

.bannerText {
    font-size: 1.2rem;
    font-weight: 400;
    color: white;
}
</style>
